import { TaskMode } from 'Types/Tasks.types'
import { sendAnalyticsTrack } from 'Utils/analytics.utils'
import { ActionConfig, ActionContext } from '../Action'

import { IAction } from '../Action'

export class SubmitAndExitAction implements IAction {
    static Id = 'SubmitAndExit' as const
    constructor(
        private actionContext: ActionContext,
        private config?: ActionConfig
    ) {
        this.addToWorkbench()
    }

    addToWorkbench() {
        this.actionContext.workbenchUiAccessor?.toolbar.addAction(
            {
                id: 'submit-and-exit',
                title: this.config?.title ?? 'Submit & Exit',
                type: 'button',
                onClick:
                    this.config?.onClick ??
                    (async () => {
                        if (this.config?.onClick) {
                            this.config.onClick()
                        } else {
                            const errorAndWarningCount =
                                this.actionContext.studio.inputManager.getErrorAndWarningCount()
                            sendAnalyticsTrack('SkipAndExit_Clicked', {
                                ...this.actionContext.task.getCommonAnalyticsObject(),
                                duration_since_task_start: Math.floor(
                                    this.actionContext.studio.taskManager.timer.getElapsedTime() /
                                        1000
                                ),
                                warning_count: errorAndWarningCount.warningCount,
                                error_count: errorAndWarningCount.errorCount,
                            })
                            const canSubmit = await this.actionContext.task.validateData()
                            if (!canSubmit) {
                                return
                            }
                            const errors =
                                this.actionContext.studio.inputManager.getViolationCount('error')
                            if (errors > 0) {
                                this.actionContext.modalManager?.showModal('violations-modal')
                                this.actionContext.task.ui?.updater.forceUpdate()
                                return
                            }
                            this.actionContext.modalManager?.showModal('submit-modal')
                        }
                        this.actionContext.task.isExiting = true
                        this.actionContext.studio.taskConfig.mode = TaskMode.Maker
                    }),
                isCollapsed: this.config?.isCollapsed ?? true,
                disabled: this.config?.disabled ?? false,
                tooltip: this.config?.tooltip,
            },
            this.config?.placement
        )
    }

    removeFromWorkbench(): void {
        this.actionContext.workbenchUiAccessor?.toolbar.removeAction('submit-and-exit')
    }
}
